export default __webpack_public_path__ + "static/media/929.e5ec7610.png";